import { COMMON_TEXT } from '@/helpers/common-text';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import './EmployeeLocationListLeft.less';
import { isEmpty } from 'lodash';
import FollowSection from '@/components/communication/EmployeeLocations/FollowSection';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class EmployeeLocationListLeft extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      branch:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0],
      isLoading: false,
      departmentList: [],
      expandedDepartments: new Set(),
    };
  }

  toggleDepartment = (departmentKey) => {
    const { expandedDepartments } = this.state;
    const newExpanded = new Set(expandedDepartments);

    if (newExpanded.has(departmentKey)) {
      newExpanded.delete(departmentKey);
    } else {
      newExpanded.add(departmentKey);
    }

    this.setState({ expandedDepartments: newExpanded });
  };

  isDepartmentSelected = (departmentKey, group) => {
    // Departments should never be selected, only teams
    return false;
  };

  handleTeamClick = (department, team, empLocGroupedByTeam, group) => {
    const key = `${group}###${department}###${team}`;
    this.props.updateSelectKeyTeam({
      selectKeyTeam: key,
      empLocGroupedByTeam: empLocGroupedByTeam[team],
      employeeSearchText: '',
    });

    if (window.innerWidth <= 811) {
      const targetDiv = document.querySelector('#listmapselectbutton');
      if (targetDiv) {
        targetDiv.scrollIntoView(
          { behavior: 'smooth', block: 'center' },
          300
        );
      }
    }
  };

  handleFollowSectionClick = () => {
    const { allEmployees, followedEmployeeIds, updateSelectKeyTeam } = this.props;

    // Filter employees who are followed
    const followedEmployees = allEmployees.filter(emp =>
      followedEmployeeIds.has(parseInt(emp.employee_id))
    );

    updateSelectKeyTeam({
      selectKeyTeam: 'FOLLOWED_EMPLOYEES',
      empLocGroupedByTeam: followedEmployees,
      employeeSearchText: '',
    });
  };

  handleAllEmployeesClick = (department, empLocGroupedByTeam, group) => {
    // Create a special key for "All employees" selection
    const key = `${group}###${department}###ALL_EMPLOYEES`;

    // Collect all employees from all teams in this department
    const allEmployees = [];
    Object.keys(empLocGroupedByTeam).forEach(teamName => {
      if (empLocGroupedByTeam[teamName] && Array.isArray(empLocGroupedByTeam[teamName])) {
        allEmployees.push(...empLocGroupedByTeam[teamName]);
      }
    });

    this.props.updateSelectKeyTeam({
      selectKeyTeam: key,
      empLocGroupedByTeam: allEmployees,
      employeeSearchText: '',
    });

    if (window.innerWidth <= 811) {
      const targetDiv = document.querySelector('#listmapselectbutton');
      if (targetDiv) {
        targetDiv.scrollIntoView(
          { behavior: 'smooth', block: 'center' },
          300
        );
      }
    }
  };

  renderGroupDepartments = (group, groupLabel) => {
    const {
      filteredEmpLocGroupedByDeptAndTeam,
      totalEmployeeMap,
      selectKeyTeam
    } = this.props;
    const { expandedDepartments } = this.state;

    const departmentList = filteredEmpLocGroupedByDeptAndTeam[group] || {};
    const isDepartmentEmpty = isEmpty(Object.keys(departmentList));

    if (isDepartmentEmpty) {
      return (
        <div key={`group-${group}`} className="group-section">
          <div className="group-header">
            <span className="group-name">{groupLabel}</span>
            <div className="no-data-container">
              {COMMON_TEXT.NO_DATA}
            </div>
          </div>
        </div>
      );
    }

    // Get sorted department names
    const departmentNames = Object.keys(departmentList)
      .filter(dept => dept !== 'NO_DEPARTMENT')
      .sort((a, b) => a.localeCompare(b, 'ja'));

    if (departmentNames.includes('NO_DEPARTMENT')) {
      departmentNames.push('NO_DEPARTMENT');
    }

    const result = [];

    // Add group header
    result.push(
      <div key={`group-header-${group}`} className="group-header">
        <span className="group-name">{groupLabel}</span>
        {isDepartmentEmpty && <div className="no-data-container">
          {COMMON_TEXT.NO_DATA}
        </div>}
      </div>
    );

    // Add departments and teams
    departmentNames.forEach((departmentName) => {
      const teamGroups = departmentList[departmentName] || {};
      const employeeCount = totalEmployeeMap[group]?.[departmentName]?.['count'] || 0;

      if (employeeCount === 0) return;

      const departmentKey = `${group}###${departmentName}`;
      const isExpanded = expandedDepartments.has(departmentKey);
      const isSelected = this.isDepartmentSelected(departmentKey, group);
      const displayName = departmentName === 'NO_DEPARTMENT' ? '部署なし' : departmentName;

      // Render department row
      result.push(
        <div
          key={departmentKey}
          className={`department-row ${isSelected ? 'selected' : ''}`}
          onClick={() => this.toggleDepartment(departmentKey)}
        >
          <span className="department-name">{displayName}</span>
          <span className="department-count">{employeeCount}</span>
          <i className={`department-chevron pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`} />
        </div>
      );

      // Render teams if expanded
      if (isExpanded) {
        // First, add the "全員" (All employees) option
        const allEmployeesKey = `${group}###${departmentName}###ALL_EMPLOYEES`;
        const isAllEmployeesSelected = selectKeyTeam === allEmployeesKey;

        result.push(
          <div
            key={allEmployeesKey}
            className={`team-row team-all ${isAllEmployeesSelected ? 'selected' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              this.handleAllEmployeesClick(departmentName, teamGroups, group);
            }}
          >
            <span className="team-name">全員</span>
            <span className="team-count">{employeeCount}</span>
            <div className="arrow-icon-v3">
              <i className="pi pi-chevron-right" />
            </div>
          </div>
        );

        // Then render individual teams
        const teamNames = Object.keys(teamGroups)
          .filter(team => team !== 'NO_TEAM')
          .sort((a, b) => a.localeCompare(b, 'ja'));

        if (teamNames.includes('NO_TEAM')) {
          teamNames.push('NO_TEAM');
        }

        teamNames.forEach((teamName) => {
          const teamEmployeeCount = totalEmployeeMap[group]?.[departmentName]?.[teamName] || 0;
          if (teamEmployeeCount === 0) return;

          const teamKey = `${group}###${departmentName}###${teamName}`;
          const isSelected = selectKeyTeam === teamKey;
          const displayTeamName = teamName === 'NO_TEAM' ? 'チームなし' : teamName;

          result.push(
            <div
              key={teamKey}
              className={`team-row ${isSelected ? 'selected' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                this.handleTeamClick(departmentName, teamName, teamGroups, group);
              }}
            >
              <span className="team-name">{displayTeamName}</span>
              <span className="team-count">{teamEmployeeCount}</span>
              <div className="arrow-icon-v3">
                <i className="pi pi-chevron-right" />
              </div>
            </div>
          );
        });
      }
    });

    return (
      <div key={`group-${group}`} className="group-section">
        {result}
      </div>
    );
  };

  renderDepartmentList = () => {
    const {
      filteredEmpLocGroupedByDeptAndTeam,
      branchName,
      departmentList
    } = this.props;
    const { branch } = this.state;

    if (!filteredEmpLocGroupedByDeptAndTeam || Object.keys(filteredEmpLocGroupedByDeptAndTeam).length === 0) {
      return <div className="no-data-container">
        {COMMON_TEXT.NO_DATA}
      </div>;
    }

    if (!departmentList || departmentList.length === 0) {
      return <div className="no-data-container">
        {COMMON_TEXT.NO_DATA}
      </div>;
    }

    const result = [];
    let newGroupList = [...departmentList];

    // Handle each group
    newGroupList.forEach((group) => {
      if (group !== String(branch) && group === 'NO_GROUP') {
        // This is the "Other Group" (他拠点)
        result.push(this.renderGroupDepartments(group, COMMON_TEXT.OTHER_GROUP));
      } else {
        // This is the main branch group
        result.push(this.renderGroupDepartments(group, branchName || '東京本社'));
      }
    });

    return result;
  };

  componentDidMount() {
    const { tenant, branch } = this.state;
    const { departmentList, isLoading, empLocGroupedByTeam } = this.props;

    this.setState({
      tenant,
      branch,
      departmentList,
      isLoading,
      empLocGroupedByTeam,
    });
  }

  componentDidUpdate(prevProps) {
    const { querystring, departmentList, isLoading, empLocGroupedByTeam } =
      this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const branch = querystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevBranch =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    const isBranchChanged = branch !== prevBranch;
    if (isTenantChanged || isBranchChanged) {
      this.setState({
        tenant,
        branch,
        isLoading,
        departmentList,
        empLocGroupedByTeam,
      });
    }
  }

  render() {
    const { followedEmployeeIds, selectKeyTeam } = this.props;

    return (
      <div className="left-container employee-location-list-left-container">
        <div className="department-list">
          <FollowSection
            followedEmployeeIds={followedEmployeeIds}
            onClick={this.handleFollowSectionClick}
            isSelected={selectKeyTeam === 'FOLLOWED_EMPLOYEES'}
          />
          {this.renderDepartmentList()}
        </div>
      </div>
    );
  }
}

EmployeeLocationListLeft.propTypes = {
  isLoading: PropTypes.bool,
  departmentList: PropTypes.array,
  departmentSearchText: PropTypes.string,
  teamSearchText: PropTypes.string,
  departmentActiveIndex: PropTypes.array,
  otherDepartmentActiveIndex: PropTypes.array,
  selectKeyTeam: PropTypes.string,
  branchName: PropTypes.string,
  totalEmployeeMap: PropTypes.object,
  filteredEmpLocGroupedByDeptAndTeam: PropTypes.object,
  allEmployees: PropTypes.array,
  followedEmployeeIds: PropTypes.instanceOf(Set),
  onFollowChange: PropTypes.func,

  updateSearchTextChange: PropTypes.func,
  updateSelectKeyTeam: PropTypes.func,
  updateActiveIndex: PropTypes.func,
};

export default EmployeeLocationListLeft;
